import { render, staticRenderFns } from "./AddEditCRM.vue?vue&type=template&id=51cd8559&scoped=true"
import script from "./AddEditCRM.vue?vue&type=script&lang=js"
export * from "./AddEditCRM.vue?vue&type=script&lang=js"
import style0 from "./AddEditCRM.vue?vue&type=style&index=0&id=51cd8559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cd8559",
  null
  
)

export default component.exports